// Labels for Beat (DESIGN_SYSTEM §8: commas, never middle dots).
import type { Project } from '../../data/types';

import { NOTE_NAMES, keyName } from '../../lib/notes';

export { NOTE_NAMES };

const dayMonth = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short' });

const sameDay = (a: number, b: number): boolean => new Date(a).toDateString() === new Date(b).toDateString();

/** "8 Oct", or "today". */
export function dayLabel(at: number, now: number): string {
  return sameDay(at, now) ? 'today' : dayMonth.format(at);
}

/** "started 8 Oct, edited today". */
export function datesLine(p: Pick<Project, 'createdAt' | 'updatedAt'>, now: number): string {
  return `started ${dayLabel(p.createdAt, now)}, edited ${dayLabel(p.updatedAt, now)}`;
}

/** "F minor", or undefined while the project has no key. */
export function keyLabel(p: Pick<Project, 'keyRoot' | 'minor'>): string | undefined {
  return p.keyRoot === undefined ? undefined : keyName(p.keyRoot, Boolean(p.minor));
}

/** The first line of the notes, for a row's meta line. */
export function firstLine(text: string): string {
  return text.split('\n').find((l) => l.trim() !== '')?.trim() ?? '';
}
